import { render, staticRenderFns } from "./DispensationMedicine.vue?vue&type=template&id=3d876490&"
import script from "./DispensationMedicine.vue?vue&type=script&lang=ts&"
export * from "./DispensationMedicine.vue?vue&type=script&lang=ts&"
import style0 from "./DispensationMedicine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports